export default __webpack_public_path__ + "static/media/clientemail.d7393a0e.svg";